






































































































































































































































































































































































































































































































import { Component, Vue } from 'nuxt-property-decorator';
import { FreeTrialButton } from '~/components';

@Component({
  components: {
    FreeTrialButton
  }
})
export default class AdultsCourse extends Vue {
  selectedItem: number = 0;
  testimonialCount: number = 3;

  schedules = [
    {
      category: '朝のレッスン',
      lessons: [
        { id: 11, level: '全レベル', weekday: '火曜日', time: '10:00-11:15' },
        { id: 13, level: '中級以上', weekday: '金曜日', time: '10:00-11:15' },
        { id: 14, level: '全レベル', weekday: '土曜日', time: '11:00-12:15' }
      ]
    },
    {
      category: '昼のレッスン',
      lessons: [
        { id: 21, level: '初心者', weekday: '月曜日', time: '13:00-14:15' },
        { id: 22, level: '初心者', weekday: '水曜日', time: '13:00-14:15' },
        { id: 23, level: '全レベル', weekday: '木曜日', time: '13:00-14:15' },
      ]
    },
    {
      category: '夜のレッスン',
      lessons: [
        { id: 30, level: '初心者', weekday: '月曜日', time: '20:00-21:15' },
        { id: 31, level: '中級以上', weekday: '月曜日', time: '20:00-21:15' },
        { id: 32, level: '全レベル', weekday: '火曜日', time: '20:00-21:15' },
        { id: 33, level: '超初心者', weekday: '水曜日', time: '20:00-21:00' },
        { id: 34, level: '初心者', weekday: '木曜日', time: '20:00-21:15' },
        { id: 35, level: '全レベル', weekday: '金曜日', time: '20:00-21:15' }
      ]
    }
  ];

  move_prev () {
    if (this.selectedItem == 0) {
      this.selectedItem = this.testimonialCount - 1;
    } else {
      this.selectedItem--;
    }
  }

  move_next () {
    this.selectedItem++;
  }

}
